import { useEffect, useState } from "react";
import { navItems } from "@/mocks/dashan";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href: string) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              go("#home");
            }}
            className="flex items-center gap-2.5 cursor-pointer"
            aria-label="搭讪吃瓜 首页"
          >
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-chat-smile-3-line text-lg md:text-xl"></i>
            </span>
            <h1 className="font-heading text-xl md:text-2xl font-bold tracking-wide text-foreground-950">
              搭讪<span className="text-primary-600">吃瓜</span>
            </h1>
          </a>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  go(item.href);
                }}
                className="px-3 py-2 rounded-full text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70 whitespace-nowrap transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                go("#faq");
              }}
              className="ml-2 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 whitespace-nowrap transition-colors cursor-pointer"
            >
              提问互动
            </a>
          </nav>

          <button
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 rounded-full bg-background-200/80 flex items-center justify-center text-foreground-900 cursor-pointer"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>

        {open && (
          <nav
            className="md:hidden pb-4 flex flex-col gap-1"
            aria-label="移动端导航"
          >
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  go(item.href);
                }}
                className="px-3 py-2.5 rounded-lg text-foreground-800 hover:bg-background-200/70 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}